import { AccountMember } from '@celum/authentication';

export interface Notification {
  typeKey: 'Notification';
  id: string;
  type: string;
  state: NotificationState;
  createdOn: number;
  senderId: string;
  receiverId: string;
  data: {
    [key: string]: any;
    affectedUserIds: string[];
    url: string;
  };
}

export enum NotificationState {
  READ = 'READ',
  UNREAD = 'UNREAD'
}

export interface NotificationWithMembers extends Notification {
  affectedUsersMap: Map<string, AccountMember>;
  sender: AccountMember;
}
